import Script from "next/script";
import type { MarketingPixelsProps } from "./MarketingPixels";

function GoogleAndMetaPixels({
  googleAnalyticsId,
  googleAdsId,
  metaPixelId,
}: Pick<
  MarketingPixelsProps,
  "googleAnalyticsId" | "googleAdsId" | "metaPixelId"
>) {
  return (
    <>
      <Script
        id="google-analytics-script"
        async
        src={`https://www.googletagmanager.com/gtag/js?id=${googleAnalyticsId}`}
      />
      <Script
        id="google-analytics-config"
        dangerouslySetInnerHTML={{
          __html: `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', '${googleAnalyticsId}');
          `,
        }}
      />
      <Script
        id="google-ads-script"
        async
        src={`https://www.googletagmanager.com/gtag/js?id=${googleAdsId}`}
      />
      <Script
        id="google-ads-config"
        dangerouslySetInnerHTML={{
          __html: `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', '${googleAdsId}');
          `,
        }}
      />
      <Script
        id="meta-pixel"
        dangerouslySetInnerHTML={{
          __html: `
            !function(f,b,e,v,n,t,s)
            {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
            n.callMethod.apply(n,arguments):n.queue.push(arguments)};
            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
            n.queue=[];t=b.createElement(e);t.async=!0;
            t.src=v;s=b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t,s)}(window, document,'script',
            'https://connect.facebook.net/en_US/fbevents.js');
            fbq('init', '${metaPixelId}');
            fbq('track', 'PageView');
          `,
        }}
      />
    </>
  );
}

function SocialPixels({
  tiktokPixelCode,
}: Pick<MarketingPixelsProps, "tiktokPixelCode">) {
  return (
    <>
      <Script
        id="tiktok-pixel"
        dangerouslySetInnerHTML={{
          __html: `
            !function (w, d, t) {
              w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];ttq.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie","holdConsent","revokeConsent","grantConsent"],ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);ttq.instance=function(t){for(
            var e=ttq._i[t]||[],n=0;n<ttq.methods.length;n++)ttq.setAndDefer(e,ttq.methods[n]);return e},ttq.load=function(e,n){var r="https://analytics.tiktok.com/i18n/pixel/events.js",o=n&&n.partner;ttq._i=ttq._i||{},ttq._i[e]=[],ttq._i[e]._u=r,ttq._t=ttq._t||{},ttq._t[e]=+new Date,ttq._o=ttq._o||{},ttq._o[e]=n||{};n=document.createElement("script")
            ;n.type="text/javascript",n.async=!0,n.src=r+"?sdkid="+e+"&lib="+t;e=document.getElementsByTagName("script")[0];e.parentNode.insertBefore(n,e)};
              ttq.load('${tiktokPixelCode}');
              ttq.page();
              if (window.location.pathname === '/thankyou') { ttq.track('CompletePayment', { contents: [], value: 60.00, currency: 'GBP' }); }
              if (window.location.pathname === '/plan') { ttq.track('AddToCart', { contents: [], value: 60.00, currency: 'GBP' }); }
            }(window, document, 'ttq');
          `,
        }}
      />
      <Script
        id="snap-pixel"
        dangerouslySetInnerHTML={{
          __html: `
            (function(e,t,n){if(e.snaptr)return;var a=e.snaptr=function(){a.handleRequest?a.handleRequest.apply(a,arguments):a.queue.push(arguments)};a.queue=[];var s='script';r=t.createElement(s);r.async=!0;r.src=n;var u=t.getElementsByTagName(s)[0];u.parentNode.insertBefore(r,u)})(window,document,'https://sc-static.net/scevent.min.js');
            snaptr('init', 'e2deaf09-2074-4151-ad9f-686e2efb23f3', {});
            snaptr('track', 'PAGE_VIEW');
            if (window.location.pathname === '/thankyou') { snaptr('track', 'PURCHASE', { price: 60.00, currency: 'GBP', transaction_id: new Date().getTime().toString(), number_items: 1 }); }
            if (window.location.pathname === '/plan') { snaptr('track', 'ADD_CART', { price: 60.00, currency: 'GBP', number_items: 1 }); }
          `,
        }}
      />
      <Script
        id="reddit-pixel"
        dangerouslySetInnerHTML={{
          __html: `
            !function(w,d){if(!w.rdt){var p=w.rdt=function(){p.sendEvent?p.sendEvent.apply(p,arguments):p.callQueue.push(arguments)};p.callQueue=[];var t=d.createElement("script");t.src="https://www.redditstatic.com/ads/pixel.js",t.async=!0;var s=d.getElementsByTagName("script")[0];s.parentNode.insertBefore(t,s)}}(window,document);
            rdt('init','a2_htgstm36pq03');
            rdt('track', 'PageVisit');
            if (window.location.pathname === '/thankyou') { rdt('track', 'Purchase'); }
            if (window.location.pathname === '/plan') { rdt('track', 'AddToCart'); }
          `,
        }}
      />
    </>
  );
}

/** Renders all marketing pixel Script tags. Split into sub-components to stay within lint limits. */
export function PixelScripts(props: MarketingPixelsProps) {
  return (
    <>
      <GoogleAndMetaPixels
        googleAnalyticsId={props.googleAnalyticsId}
        googleAdsId={props.googleAdsId}
        metaPixelId={props.metaPixelId}
      />
      <SocialPixels tiktokPixelCode={props.tiktokPixelCode} />
    </>
  );
}
